import React, { FC } from 'react';
import { Tag } from 'antd';
import * as texts from 'assets/texts/localizedText';
import { TranslationLanguage } from 'apollo/localizedTypes';

export interface TranslationStatusProps {
  missingTranslations: TranslationLanguage[];
}

export const TranslationStatus: FC<TranslationStatusProps> = ({
  missingTranslations,
}: TranslationStatusProps) => {
  if (!missingTranslations.length) {
    return <Tag color="green">{texts.translated}</Tag>;
  }

  return (
    <>
      {missingTranslations.map((language) => (
        <Tag color="orange" key={language}>
          {language.toUpperCase()}
        </Tag>
      ))}
    </>
  );
};

export default TranslationStatus;
